import {State} from '@ngxs/store';
import {ReportStateModel} from '@store/report/report/report-state.model';
import {Injectable} from '@angular/core';
import {IDevice} from '@interfaces/devices';
import {IGroup} from '@interfaces/group';
import {IMediaItem} from '@interfaces/media';
import {IPlaylist} from '@interfaces/playlist';
import {NgxsDataRepository} from '@angular-ru/ngxs/repositories';
import {Payload, StateRepository} from '@angular-ru/ngxs/decorators';
import {DataActionWithoutSubscription} from '@shared/functions';

@StateRepository()
@State<ReportStateModel>({
    name: 'reportState',
    defaults: {
     device: null,
     group: null,
     playlist: null,
     media: null,
     start: '',
     end: '',
    }
})


@Injectable()
export class ReportState extends NgxsDataRepository<ReportStateModel> {
    constructor() {
        super();
    }

    @DataActionWithoutSubscription()
    setDevice(@Payload('[Report info] set device') device: IDevice): void {
        this.ctx.patchState({device, group: null});
    }

    @DataActionWithoutSubscription()
    setGroup(@Payload('[Report info] set group') group: IGroup): void {
        this.ctx.patchState({group, device: null});
    }

    @DataActionWithoutSubscription()
    setMedia(@Payload('[Report info] set media') media: IMediaItem): void {
        this.ctx.patchState({media, playlist: null});
    }

    @DataActionWithoutSubscription()
    setPlaylist(@Payload('[Report info] set playlist') playlist: IPlaylist): void {
        this.ctx.patchState({playlist, media: null});
    }

    @DataActionWithoutSubscription()
    setPeriod(@Payload('[Report info] set time period') {start, end}: {start: string, end: string}): void {
        this.ctx.patchState({start, end});
    }
}
